<template>
  <div class="custom_month_picker">
    <div class="header">
      <span
        @click="setYear(y.date)"
        v-for="y in years"
        :key="y.id"
        :class="{ '-selected': y.selected }"
      >
        {{ $moment(y.date).format("YYYY") }}
      </span>
    </div>
    <div class="body">
      <div class="wrapper">
        <div
          v-for="y in years"
          :key="y.id"
          class="year"
          :class="{ '-selected': y.selected }"
        >
          <div
            v-for="m in y.months"
            :key="m.id"
            class="month"
            @click="picked(m)"
          >
            {{ $moment(m).format("MMM") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      years: [],
      now: new Date().getTime(),
      position: 0
    };
  },
  methods: {
    setYear(year) {
      for (const y in this.years) {
        this.$set(
          this.years,
          y,
          Object.assign(this.years[y], {
            selected: this.years[y].date === year
          })
        );
      }
    },
    picked(ts) {
      const full = new Date(ts).getFullYear() < new Date().getFullYear();
      this.$emit("picked", { date: ts, full });
    },
    createYears() {
      const values = [
        new Date().setFullYear(new Date().getFullYear() - 1),
        this.now,
        new Date().setFullYear(new Date().getFullYear() + 1)
      ];

      let MM = 0;

      while (MM < 12) {
        for (const [i, v] of values.entries()) {
          const m = new Date(v).setMonth(MM);
          const d = new Date(m).setDate(1);
          const h = new Date(d).setHours(0, 0, 0, 0);

          if (!this.years[i])
            this.years[i] = { date: v, months: [], selected: v === this.now };
          this.years[i].months[MM] = h;
        }
        MM++;
      }
    }
  },
  beforeMount() {
    this.createYears();
  }
};
</script>
